import { html, type TemplateResult } from 'lit';

export function renderShipInformation(shipInformationData: {
    title: string;
    content: string | null | undefined;
}): TemplateResult | null {
    if (!shipInformationData?.content) {
        return null;
    }

    return html`
        <div class="productinfo-ship-information">
            <der-ui-tile title="${shipInformationData.title}" content="${shipInformationData.content}"></der-ui-tile>
        </div>
    `;
}
